import { type PraticaDomandaDTO } from '@framework/api-client/api/inquiries-compile/schemas/praticaDomandaDTO.ts';
import dayjs from 'dayjs';

/**
 * Calcola le data di validità per avvio di una domanda secondaria,
 * se presente.
 */
export function getStartableInquiryDates(
  startableData: Pick<PraticaDomandaDTO, 'start' | 'end' | 'life'> | undefined,
) {
  if (!startableData) {
    return { startDate: null, endDate: null };
  }

  const startDate = startableData.start
    ? dayjs(startableData.start, 'YYYY-MM-DD')
    : null;
  const endDate = startableData.end
    ? dayjs(startableData.end, 'YYYY-MM-DD')
    : startableData.life != null
      ? startDate?.add(startableData.life, 'day')
      : null;

  return {
    startDate,
    endDate,
  };
}
